const burgerMenuToggle = document.querySelector(".burger-menu-toggle");
const mobileMenu = document.querySelector(".mobile-menu");
const dropdownToggles = document.querySelectorAll(".mobile-dropdown-icon");
const burgerIcon = document.querySelector(".burger-icon");
const closeIcon = document.querySelector(".close-icon");

function toggleIcons() {
  burgerIcon.style.display =
    burgerIcon.style.display === "none" ? "block" : "none";
  closeIcon.style.display =
    closeIcon.style.display === "none" ? "block" : "none";
}

function toggleDropdownIcons(dropdown) {
  const downIcon = dropdown.querySelector(".down-icon");
  const aboveIcon = dropdown.querySelector(".above-icon");

  if (downIcon && aboveIcon) {
    downIcon.style.display =
      downIcon.style.display === "none" ? "block" : "none";
    aboveIcon.style.display =
      aboveIcon.style.display === "none" ? "block" : "none";
  }
}

function toggleScrollLock() {
  if (mobileMenu.classList.contains("active")) {
    document.body.classList.add("no-scroll");
  } else {
    document.body.classList.remove("no-scroll");
  }
}

burgerMenuToggle.addEventListener("click", () => {
  mobileMenu.classList.toggle("active");
  toggleIcons();
  toggleScrollLock();
});

let activeDropdown = null;

dropdownToggles.forEach((dropdownToggle) => {
  dropdownToggle.addEventListener("click", (e) => {
    e.stopPropagation();

    const dropdownMenu = dropdownToggle.nextElementSibling;

    if (activeDropdown && activeDropdown !== dropdownMenu) {
      activeDropdown.classList.remove("active");
      activeDropdown.previousElementSibling.classList.remove("active");
      const prevDownIcon = activeDropdown.previousElementSibling.querySelector(".down-icon");
      const prevAboveIcon = activeDropdown.previousElementSibling.querySelector(".above-icon");
      prevDownIcon.style.display = "block";
      prevAboveIcon.style.display = "none";
    }

    dropdownMenu.classList.toggle("active");
    dropdownToggle.classList.toggle("active");

    const downIcon = dropdownToggle.querySelector(".down-icon");
    const aboveIcon = dropdownToggle.querySelector(".above-icon");

    if (dropdownMenu.classList.contains("active")) {
      downIcon.style.display = "none";
      aboveIcon.style.display = "block";
      activeDropdown = dropdownMenu;
    } else {
      downIcon.style.display = "block";
      aboveIcon.style.display = "none";
      activeDropdown = null;
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const dropdowns = document.querySelectorAll(".mobile-dropdown");

  document.addEventListener("click", function (event) {
    if (activeDropdown && !activeDropdown.contains(event.target)) {
      activeDropdown.classList.remove("active");
      activeDropdown.previousElementSibling.classList.remove("active");
      const prevDownIcon = activeDropdown.previousElementSibling.querySelector(".down-icon");
      const prevAboveIcon = activeDropdown.previousElementSibling.querySelector(".above-icon");
      prevDownIcon.style.display = "block";
      prevAboveIcon.style.display = "none";
      activeDropdown = null;
    }
  });
});
